import { useChatContext } from 'containers/chat/hooks/ChatContext';
import { useMemo, useRef } from 'react';
import { Spinner } from 'react-bootstrap';
import InfiniteScroll from 'react-infinite-scroller';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import themes from 'styles/themes';
interface ConversationListProps {
    handleListOptionClick: (value: any) => void;
    handleNewConversation: () => void;
    handleArchivedThread: () => void;
    conversationListLoading: boolean;
    isArchivedThreadLoading: boolean;
}

export default function ConversationList({
    handleListOptionClick,
    handleNewConversation,
    conversationListLoading,
    isArchivedThreadLoading,
    handleArchivedThread,
}: ConversationListProps) {
    const scrollParentRef = useRef<any>(null);
    const { conversation } = useChatContext();
    const conversationList = useSelector((state: RootState) => state.chat.conversationList);
    const isArchivedThread = useSelector((state: RootState) => state.chat.isArchivedThread);
    const isDisplayArchivedThread = useSelector((state: RootState) => state.chat.isDisplayArchivedThread);

    const Loader = () => {
        return (
            <div className="loader" key={'loader'}>
                {' '}
                <Spinner animation="border" style={{ width: 20, height: 20, color: themes.palette.primary.main }} />
            </div>
        );
    };

    const NoStyleThread = () => {
        return (
            <div className="auto-container text-center">
                <div>🧵</div>
                <div className="text-title mt-15">No style threads yet</div>
                <div className="mt-15">Your recent styling sessions with Amira will appear here.</div>
                <div className="mt-15">Let us start your first session and get you styled. 👗🕴️</div>
                <button className="ask-amira-button mt-15" onClick={handleNewConversation}>
                    <div className="button-title">Ask Amira</div>
                </button>
                {isArchivedThread ? (
                    <div className="mt-50">
                        view your{' '}
                        <span className="link-text" onClick={handleArchivedThread}>
                            Archived Threads
                        </span>{' '}
                        from earlier sessions.
                    </div>
                ) : null}
            </div>
        );
    };

    const isListAvailable = conversationList?.length;
    const isListLoading =
        (conversationListLoading && !conversationList.length) || (isArchivedThreadLoading && !isArchivedThread);

    const isConversationListAvailable = useMemo(
        () => conversationList?.length || isListLoading,
        [conversationList, isListLoading],
    );

    return (
        <>
            <p className="sidebarTitle" style={{ display: isConversationListAvailable ? 'block' : 'none' }}>
                Threads
            </p>
            <div id="scrollableDiv" className="scroll-container" ref={(ref) => (scrollParentRef.current = ref)}>
                {isListAvailable ? (
                    <InfiniteScroll
                        pageStart={0}
                        loadMore={() => {}}
                        hasMore={false}
                        loader={<Loader />}
                        threshold={100}
                        useWindow={false}
                        getScrollParent={() => scrollParentRef.current}
                    >
                        {conversationList.map((item, index) => {
                            return (
                                <div
                                    key={index}
                                    onClick={() => handleListOptionClick(item)}
                                    style={{
                                        fontWeight: conversation?.id === item?.id ? 'bold' : 'normal',
                                    }}
                                    className="list-option"
                                >
                                    {item?.title}
                                </div>
                            );
                        })}
                        {isArchivedThread ? (
                            <div
                                key={'ArchivedThread'}
                                onClick={() => handleArchivedThread()}
                                style={{
                                    fontWeight: isDisplayArchivedThread ? 'bold' : 'normal',
                                }}
                                className="list-option mt-50"
                            >
                                Archived Threads
                            </div>
                        ) : null}
                    </InfiniteScroll>
                ) : isListLoading ? (
                    <Loader />
                ) : (
                    <NoStyleThread />
                )}
            </div>
        </>
    );
}
